import { CUSTOMERS_SUCCESSFUL_FETCH, CUSTOMERS_SUCCESSFUL_SAVE } from 'reducers/constants';

const initialState = {
    items: [],
    item: {}
}

export default function (state = initialState, action) {
    switch (action.type) {
        case CUSTOMERS_SUCCESSFUL_FETCH:
            return {
                ...state,
                items: action.payload.slice()
            }

        case CUSTOMERS_SUCCESSFUL_SAVE:
            return {
                ...state,
                item: Object.assign({}, action.payload)
            }

        default:
            return state;

    }
}


// WEBPACK FOOTER //
// ./src/reducers/customer/customerReducer.js